import { render, staticRenderFns } from "./MainMenuContainer.vue?vue&type=template&id=6d835724&scoped=true"
import script from "./MainMenuContainer.vue?vue&type=script&lang=js"
export * from "./MainMenuContainer.vue?vue&type=script&lang=js"
import style0 from "./MainMenuContainer.vue?vue&type=style&index=0&id=6d835724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d835724",
  null
  
)

export default component.exports